module.exports = __webpack_public_path__ + "intern.2qowckIP.jpg";